var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FullMasterTemplate',{scopedSlots:_vm._u([{key:"gnb",fn:function(){return [_c('GnbLeftView')]},proxy:true}])},[(_vm.isUseLeftMenu)?_c('LeftMenu',{attrs:{"item":_vm.menuItem}}):_vm._e(),_c('ContentComponent',{attrs:{"item":_vm.menuItem,"isUseLeftMenu":_vm.isUseLeftMenu}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }